/* eslint-disable max-len */
import React from 'react';

const Minus: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 10H2" stroke={props.color ?? props?.style?.color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default Minus;
